import { createSelector } from 'reselect';
import { raw } from './selectors.raw';

export const $example = createSelector(raw.$rawAppState, (appState) => {
  const { isAuthenticated, isLoading } = appState;

  return {
    a: 10,
    c: 10,
    isLoading,
    isAuthenticated,
  };
});

export const $example2 = createSelector(raw.$rawAppState, (appState) => {
  const { isAuthenticated, isLoading } = appState;

  return {
    a: 10,
    b: 5,
    isLoading,
    isAuthenticated,
  };
});
